var codeblock_default = {
  "blockStyleSpacing": "_4EUF1",
  "codeBlock": "Rreaj _4EUF1",
  "renderedInTable": "PQMda"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock.scss.js.map
